<template>
  <div>
    <h5>My Story</h5>
    <p class="desc">{{myStory.summary}}</p>
    <p class="desc">{{myStory.story}}</p>
    <!-- s1~s5 for work history on the right -->
    <p v-for="job in jobs" class="desc" :class="job.id" :key="job.id"><em class="count">{{job.year}}</em>{{job.description}}</p>
  </div>
</template>

<<script>
export default {
  name: 'story',
  props: {
    jobs: Array,
    myStory: Object
  }
}
</script>

<<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Story.vue